import { render } from "./AppWidgetButton.vue?vue&type=template&id=3fe1b97a&scoped=true"
import script from "./AppWidgetButton.vue?vue&type=script&lang=ts"
export * from "./AppWidgetButton.vue?vue&type=script&lang=ts"

import "./AppWidgetButton.vue?vue&type=style&index=0&id=3fe1b97a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3fe1b97a"

export default script